import { Identifiers, SectionsKey } from '~/constants/enum';

const PageStruct = {
    id: 'home',
    useLayout: true,
    children: [
        { id: SectionsKey.Hero, order: 1, identifier: Identifiers.Hero },
        { id: SectionsKey.PromotionBanner, order: 2, identifier: Identifiers.PromotionBanner },
        { id: SectionsKey.Brand, order: 3, identifier: Identifiers.HomeBrand },
        { id: SectionsKey.ProductMatching, order: 4, identifier: Identifiers.ProductMatching },
        { id: SectionsKey.RecentlyView, order: 5 },
        { id: SectionsKey.TopCategory, order: 6, identifier: Identifiers.TopCategories },
        { id: SectionsKey.BestSeller, order: 7, identifier: Identifiers.BestSeller },
        { id: SectionsKey.MostPopular, order: 8, identifier: Identifiers.MostPopular },
        { id: SectionsKey.FeatureProduct, order: 9, identifier: Identifiers.FeatureProduct },
        { id: SectionsKey.NewCollections, order: 10, identifier: Identifiers.NewCollection },
        { id: SectionsKey.Trending, order: 11, identifier: Identifiers.TrendingBanner },
        { id: SectionsKey.Testimonial, order: 12, dataKey: SectionsKey.Testimonial, identifier: Identifiers.Testimonial },
        { id: SectionsKey.Recommended, order: 13, identifier: Identifiers.Recommended }
    ]
};

export default PageStruct;
